import axios from 'axios';

export const lineTypeWorkApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/line-type-work`,
    headers: {
        'Content-Type': 'application/json'
    }
})